(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-tab"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Carga un panel bajo demanda vía Section Rendering API:
  // /collections/<handle>?section_id=<id> devuelve esta misma sección
  // renderizada en el contexto de esa colección (su pestaña sale activa
  // con las tarjetas ya montadas) y extraemos el panel correspondiente.
  function loadPanel(section, panel) {
    if (panel.dataset.loading === 'true' || panel.dataset.loaded === 'true') return;
    panel.dataset.loading = 'true';

    var sectionId = section.getAttribute('data-section-id');
    var base = panel.dataset.collectionUrl;
    var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

    if (!panel.childElementCount) {
      panel.innerHTML = '<div class="product-tabs__loading" aria-busy="true" aria-label="Cargando"></div>';
    }

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var remote = doc.querySelector('.product-tabs__panel[data-panel-index="' + panel.dataset.panelIndex + '"]');
        if (!remote || !remote.childElementCount) throw new Error('panel vacío en la respuesta');
        panel.innerHTML = '';
        while (remote.firstChild) panel.appendChild(remote.firstChild);
        panel.dataset.loaded = 'true';
        window.dispatchEvent(new Event('resize'));
      })
      .catch(function (err) {
        console.error('[product-tabs] carga diferida falló:', err);
        panel.innerHTML =
          '<a class="product-tabs__fallback-link" href="' + base + '">Ver colección</a>';
      })
      .finally(function () {
        delete panel.dataset.loading;
      });
  }

  function hydratePanel(section, panel) {
    // Editor de temas: el contenido viene en <template>
    var tpl = panel.querySelector('template.product-tabs__deferred');
    if (tpl) {
      panel.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
      return;
    }
    // Tienda: panel vacío → cargar bajo demanda
    if (!panel.dataset.loaded && !panel.childElementCount && panel.dataset.collectionUrl) {
      loadPanel(section, panel);
    }
  }

  function initTabs(root) {
    var sections = root.querySelectorAll
      ? root.querySelectorAll('.section-product-tabs')
      : [];

    sections.forEach(function (section) {
      // Evitar doble inicialización (el editor re-renderiza secciones)
      if (section.dataset.tabsInit === 'true') return;
      section.dataset.tabsInit = 'true';

      var nav = section.querySelector('.product-tabs__nav');
      var panelsWrap = section.querySelector('[data-tabs-panels]');
      if (!nav || !panelsWrap) return;

      // Precarga al pasar el ratón/foco por una pestaña aún no cargada
      nav.addEventListener('pointerover', function (e) {
        var btn = e.target.closest('.product-tabs__btn');
        if (!btn) return;
        var idx = btn.getAttribute('data-tab-index');
        var panel = panelsWrap.querySelector('.product-tabs__panel[data-panel-index="' + idx + '"]');
        if (panel && !panel.childElementCount && !panel.querySelector('template') && panel.dataset.collectionUrl) {
          loadPanel(section, panel);
        }
      });

      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('.product-tabs__btn');
        if (!btn) return;

        var idx = btn.getAttribute('data-tab-index');

        nav.querySelectorAll('.product-tabs__btn').forEach(function (b) {
          var active = b.getAttribute('data-tab-index') === idx;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panelsWrap.querySelectorAll('.product-tabs__panel').forEach(function (p) {
          var active = p.getAttribute('data-panel-index') === idx;

          // Hidratar contenido diferido la primera vez que se abre la pestaña
          if (active) {
            hydratePanel(section, p);
          }

          p.classList.toggle('is-active', active);
          if (active) {
            p.removeAttribute('hidden');
          } else {
            p.setAttribute('hidden', '');
          }
        });

        // Los carruseles miden 0px mientras están ocultos; forzar recálculo
        window.dispatchEvent(new Event('resize'));

        if (btn.scrollIntoView) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }

        section.dispatchEvent(new CustomEvent('product-tabs:changed', {
          bubbles: true,
          detail: { index: idx, handle: btn.getAttribute('data-collection-handle') }
        }));
      });
    });
  }

  initTabs(document);

  // El editor de temas re-renderiza la sección al cambiar ajustes:
  // hay que volver a inicializar los listeners
  document.addEventListener('shopify:section:load', function (e) {
    initTabs(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
